export const getPriceFromContainerInfo = (containerInfo) => {
  if (!containerInfo?.itemPrices) {
    return null;
  }

  const price = Array.isArray(containerInfo.itemPrices)
    ? containerInfo.itemPrices[containerInfo.selectedPriceIndex || 0]
    : containerInfo.itemPrices;

  return price;
};

export const getPriceAmount = (containerInfo) => {
  const price = getPriceFromContainerInfo(containerInfo);
  return price?.amount || 0;
};

export const getPriceCurrency = (containerInfo, useSymbol = true) => {
  const price = getPriceFromContainerInfo(containerInfo);

  if (!price?.currency) {
    return "";
  }

  if (useSymbol && price.currency === "USD") {
    return "$ ";
  }

  return price.currency + " ";
};

export const formatAmount = (amount, minDecimals = 2, maxDecimals = 3) => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return "0.00";
  }

  return Number(amount).toLocaleString("en-US", {
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals,
  });
};

export const formatPrice = (
  containerInfo,
  withSpace = true,
  useFormatting = true,
) => {
  const priceObj = getPriceFromContainerInfo(containerInfo);

  if (!priceObj) {
    return "";
  }

  const currency = priceObj.currency === "USD" ? "$" : priceObj.currency || "";
  const space = withSpace ? " " : "";
  const amount = useFormatting
    ? formatAmount(priceObj.amount)
    : priceObj.amount;

  return `${currency}${space}${amount}`;
};

export const calculateSubTotal = (order) => {
  const unitPrice = getPriceAmount(order.containerInfo);
  const quantity = parseInt(order.quantity, 10) || 0;
  return unitPrice * quantity;
};

export const calculateTotalPrice = (orderList) => {
  const orderWithPrice = orderList.find(
    (order) => order.containerInfo?.itemPrices,
  );

  const currency = orderWithPrice
    ? getPriceCurrency(orderWithPrice.containerInfo, true)
    : "";

  const total = orderList.reduce((acc, order) => {
    return acc + calculateSubTotal(order);
  }, 0);

  return {
    currency,
    total,
    formatted: currency && total > 0 ? `${currency}${formatAmount(total)}` : "",
  };
};
